import { create } from 'zustand';

interface AuthRouterStore {
    currentRoutingPath: string;
    setCurrentRoutingPath: (path: string) => void;

    pendingAuthenticatedRoutePath: string | null;
    setPendingAuthenticatedRoutePath: (path: string) => void;
    resetPendingAuthenticatedRoutePath: () => void;
}

const useAuthRouterStore = create<AuthRouterStore>((set) => ({
    pendingAuthenticatedRoutePath: null,
    setPendingAuthenticatedRoutePath: (path) => {
        set({ pendingAuthenticatedRoutePath: path });
    },
    resetPendingAuthenticatedRoutePath: () => {
        set({ pendingAuthenticatedRoutePath: null });
    },
    currentRoutingPath: '',
    setCurrentRoutingPath: (path) => {
        set({ currentRoutingPath: path });
    },
}));

export default useAuthRouterStore;
